module.exports = __webpack_public_path__ + "img/kyc-selfy.0412273e.jpg";